import { FunctionComponent } from 'react'
import { HasClassName } from '~/models/HasClassName'
import { Blok, BlokProps, SeoMetaTagsPluginField, StoryblokComponent } from '@storyblok/react'
import { Background } from 'models/Background'
import { BaseLayout } from '~/components/BaseLayout/BaseLayout'
import { SupportTrigger } from '~/components/SupportTrigger/SupportTrigger'
import { GlobalOffset } from '../Partials/Global/GlobalOffset'
import { GlobalPartnerFooter } from '../Partials/Global/GlobalPartnerFooter'
import { GlobalPartnerNavigation } from '../Partials/Global/GlobalPartnerNavigation'
import { SeoMetaTags } from '~/components/SeoMetaTags/SeoMetaTags'
import Head from 'next/head'


interface PageBlok extends Blok {
  meta: SeoMetaTagsPluginField
  offset: Background
  sections: Blok[]
}

interface Props {
  blok: PageBlok,
  story: any,
}

export const PartnerPage: FunctionComponent<Props> = ({ story, blok }) => {
  return (
    <BaseLayout>
      <Head>
        <title>{blok.meta.title}</title>
        {SeoMetaTags(blok.meta)}
      </Head>

      <GlobalPartnerNavigation
        phone={story.content.phone}
        logo={story.content.logo}
        text={story.content.text}
      />

      <main className="min-h-screen">
        <GlobalOffset
          className="pt-32 lg:pt-20"
          theme="WHITE"
        />

        {story.content.sections.map((section:any) => <StoryblokComponent blok={section} key={section._uid} story={story}/>)}

        <div className="sticky bottom-0 z-20 flex justify-end">
          <SupportTrigger className="mb-3 mr-3 -mt-16 md:mr-4 md:mb-4 md:-mt-20" />
        </div>
      </main>

      <GlobalPartnerFooter />
    </BaseLayout>
  )
}
